/* eslint-disable no-restricted-globals */

let baseUrl = "http://localhost:3000/api/v1";
let uploadUrl = "http://localhost:3000/api/v1/rails/active_storage/direct_uploads";
let healthcheckUrl = "http://localhost:3000/";
let logrocketKey = "ctm/ctm-staging";
let logrocketEnabled = false;

const subdomain = (window || self).location.host.split(".").shift();
console.log("using configuration for subdomain", subdomain);
switch (subdomain) {
  case "localhost:5000":
  case "localhost:5555":
  case "localhost:8000":
  case "ctm-volatile":
  case "staging-app":
  case "d3oxiixfui9jgt":
    baseUrl = "https://ctm-staging.twinsun.dev/api/v1";
    uploadUrl = "https://ctm-staging.twinsun.dev/api/v1/rails/active_storage/direct_uploads";
    healthcheckUrl = "https://ctm-staging.twinsun.dev/";
    logrocketEnabled = true;
    break;
  case "ctm":
  case "app":
  case "dagfk71hdvk31":
    baseUrl = "https://ctm-api.twinsun.dev/api/v1";
    uploadUrl = "https://ctm-api.twinsun.dev/api/v1/rails/active_storage/direct_uploads";
    healthcheckUrl = "https://ctm-api.twinsun.dev/";
    logrocketEnabled = true;
    logrocketKey = "ctm/ctm-production";
    break;
  default:
    break;
}

const baseConfig = {
  api: {
    baseUrl,
    uploadUrl,
    healthcheckUrl,
  },
  logrocket: {
    enabled: logrocketEnabled,
    key: logrocketKey,
  },
};

export default baseConfig;
